import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { PipelineLicenseStakeholderDto, StakeholderRepDto } from '@cradua/data';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';


@Component({
  selector: 'cradua-stakeholderrep-container',
  templateUrl: './stakeholderrep-container.component.html',
  styleUrls: ['./stakeholderrep-container.component.scss']
})
export class StakeholderrepContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  stakeholderreps$: Observable<StakeholderRepDto[]>;
  stakeholders$: Observable<PipelineLicenseStakeholderDto[]>;
  loading: boolean;
  isLoadingStakeholderrep$: Observable<boolean>;
  isLoadingStakeholder$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.isLoadingStakeholderrep$ = this.gatwayFacade.isLoadingGateway("StakeholderRep");
     this.isLoadingStakeholder$ = this.gatwayFacade.isLoadingGateway("PipelineLicenseStakeholder");
    
     this.stakeholderreps$ = this.gatwayFacade.loadGateway("StakeholderRep");
     this.stakeholders$ = this.gatwayFacade.loadGateway("PipelineLicenseStakeholder");
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

    onDeleteStakeholderrep(deletedValue: any) {
    this.gatwayFacade.remove("StakeholderRep", deletedValue);
  }


// this method control both the create and update

onSubmitStakeholderrep(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.StakeholderReps;
    console.log('Submit', pullData);

// declare two empty arrays to hold update and create data
  const allUpdates = [] ;
  const addAllStakeholderRep = [];


// loop through the form data to check for update and create
  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id != null) {
      
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllStakeholderRep.push(pullData[i]);
    }
  }
  console.log('Checking add', addAllStakeholderRep.length);
// check if the addAllStakeholderRep array is not empty, then dispatch the data to the store
   if(addAllStakeholderRep.length > 0) {
   
    this.gatwayFacade.add('StakeholderRep', addAllStakeholderRep);
   }

   if(allUpdates.length > 0) {
     // dispatch update data to the store
    this.gatwayFacade.update('StakeholderRep', allUpdates, ['id']);
  }

   }


}
